import React, { useState } from "react";
import { Menu, X, Truck } from "lucide-react";
import { BRAND } from "../../lib/constants";

const LINKS = [
  { href: "/#services", label: "Services" },
  { href: "/#why-us", label: "Why Us" },
  { href: "/#coverage", label: "Coverage" },
  { href: "/blog", label: "Blog" },
  { href: "/#faq", label: "FAQ" },
  { href: "/#contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header
      className="sticky top-0 z-50 bg-[#F4F4F1] border-b-2 border-[#122A1E]"
      data-testid="site-header"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <a
          href="#top"
          className="flex items-center gap-2 group"
          data-testid="nav-logo"
        >
          <div className="w-9 h-9 bg-[#122A1E] text-[#F4F4F1] flex items-center justify-center">
            <Truck size={18} strokeWidth={2.5} />
          </div>
          <div className="leading-tight">
            <div className="font-display font-black uppercase tracking-tighter text-[15px] text-[#0A0E0C]">
              M&R Hauling
            </div>
            <div className="font-mono-accent text-[9px] text-[#4A5550]">
              COAST · TO · COAST
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-7">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="font-mono-accent text-[11px] uppercase text-[#0A0E0C] hover:text-[#FF5A00] transition-colors"
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="/#quote"
            className="bg-[#FF5A00] hover:bg-[#E04F00] text-white font-display font-bold uppercase text-xs tracking-wider px-5 py-3 border-2 border-[#122A1E] hard-shadow-sm hover-lift inline-block"
            data-testid="nav-cta-quote"
          >
            Get Instant Quote
          </a>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center border-2 border-[#122A1E]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t-2 border-[#122A1E] bg-[#F4F4F1] px-6 py-4 flex flex-col gap-4" data-testid="mobile-nav">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-mono-accent text-xs uppercase text-[#0A0E0C]"
              data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="/#quote"
            onClick={() => setOpen(false)}
            className="bg-[#FF5A00] text-white font-display font-bold uppercase text-xs tracking-wider px-5 py-3 border-2 border-[#122A1E] text-center"
            data-testid="mobile-nav-cta"
          >
            Get Instant Quote
          </a>
          <div className="font-mono-accent text-[10px] text-[#4A5550]">
            {BRAND.phone}
          </div>
        </div>
      )}
    </header>
  );
}
